import Backlink from "../../components/Backlink";
import HeaderContainer from "../../components/container/HeaderContainer";

const TrainingVideos = () => {
  return (
    <section className="w-full text-primary">
      <Backlink>Back</Backlink>
      <section className="my-8 text-primary w-full">
        <HeaderContainer title="Training Videos">
          <div className="grid grid-cols-1 gap-16">
            <div>
              {/* <h1 className="text-xl md:text-2xl font-bold mb-2">Bulk Edit of Site Visit Demo Video</h1> */}
          <div className="pt-[56.25%] relative">
            <iframe
              src="https://player.vimeo.com/video/1036535938?h=c6f53d2df5&badge=0&autopause=0&player_id=0&app_id=58479"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="Bulk Edit of Site Visit Demo Video"
            ></iframe>
          </div>
            </div>
            <div>
              {/* <h1 className="text-xl md:text-2xl font-bold mb-2">Summary File Access Demo Video</h1> */}
              <div className="pt-[56.25%] relative">
                <iframe 
                src="https://player.vimeo.com/video/1072306230?h=12ecf6d66e&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" 
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
                title="Viewing Files and Field Data">
                  </iframe>
                  </div>
            </div>
          </div>
        
        </HeaderContainer>
      </section>
    </section>
  );
};
export default TrainingVideos;
